import RichInputEditor from "../../RichInputEditor/RichInputEditor";

// Saisie d'un nouveau commentaire. `onCancel`, `autoFocus` et `compact` sont
// transmis à l'éditeur pour les saisies repliables (carte lead auto).
const AddCommentForm = ({ addComment, users = [], onCancel, autoFocus = false, compact = false }) => {
  const onSubmit = (commentData) => {
    addComment(commentData.comment);
  };

  return <RichInputEditor onSubmit={onSubmit} users={users} onCancel={onCancel} autoFocus={autoFocus} compact={compact} />;
};

export default AddCommentForm;
